<template>
  <div class="filter">
    <div class="filter-form">
      <el-row :gutter="24" type="flex">
        <el-col
          v-for="item in filterForm"
          :key="item.field"
          :sm="12"
          :md="12"
          :lg="12"
          :xl="item.span || 6"
        >
          <div class="filter-item">
            <label>{{ item.name }}</label>
            <template v-if="item.type == 'input'">
              <el-input
                @keyup.enter.native="onSearch(true)"
                @clear="onSearch(true)"
                v-model="form[item.field]"
                size="large"
                :placeholder="`请输入${item.name}`"
              ></el-input>
            </template>
            <template v-if="item.type == 'date'">
              <el-date-picker
                @change="onSearch"
                v-model="startDate"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="date"
                placeholder="开始时间"
                size="large"
              ></el-date-picker>
              <span style="padding: 0 4px"> - </span>
              <el-date-picker
                @change="onSearch"
                v-model="endDate"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="date"
                placeholder="结束时间"
                size="large"
              ></el-date-picker>
            </template>
            <template v-if="item.type == 'tree'">
              <el-cascader
                @change="onSearch"
                v-model="form[item.field]"
                :show-all-levels="false"
                :options="tree"
                :props="{
                  value: 'deptId',
                  label: 'deptName',
                  checkStrictly: item.checkStrictly,
                }"
                size="large"
              ></el-cascader>
            </template>
            <template v-if="item.type == 'select'">
              <el-select
                v-model="form[item.field]"
                size="large"
                placeholder="请选择"
                @change="onSearch"
              >
                <el-option
                  v-for="i in item.options"
                  :key="i.value"
                  :label="i.label"
                  :value="i.value"
                >
                </el-option>
              </el-select>
            </template>
            <template v-if="item.type == 'typeSelect'">
              <el-select
                v-model="form[item.field]"
                size="large"
                placeholder="请选择"
                @change="onSearch"
              >
                <el-option
                  v-for="i in eventType"
                  :key="i.value"
                  :label="i.label"
                  :value="i.value"
                >
                </el-option>
              </el-select>
            </template>
            <template v-if="item.type == 'typeEnvSelect'">
              <el-select
                v-model="form[item.field]"
                size="large"
                placeholder="请选择"
                @change="onSearch"
              >
                <el-option
                  v-for="i in enVEventType"
                  :key="i.value"
                  :label="i.label"
                  :value="i.value"
                >
                </el-option>
              </el-select>
            </template>
            <template v-if="item.type == 'levelSelect'">
              <el-select
                v-model="form[item.field]"
                size="large"
                placeholder="请选择"
                @change="onSearch"
              >
                <el-option
                  v-for="i in options2"
                  :key="i.value"
                  :label="i.label"
                  :value="i.value"
                >
                </el-option>
              </el-select>
            </template>
            <template v-if="item.type == 'hiddenSelect'">
              <el-select
                v-model="form[item.field]"
                size="large"
                placeholder="请选择"
                @change="onSearch"
              >
                <el-option
                  v-for="i in options3"
                  :key="i.value"
                  :label="i.label"
                  :value="i.value"
                >
                </el-option>
              </el-select>
            </template>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="filter-button" v-if="needBtn">
      <!--      <el-button class="onBtn" type="primary" @click="onSearch(true)"-->
      <!--        >查询</el-button-->
      <!--      >-->
      <el-button class="onBtn" @click="onReset">重置</el-button>
    </div>
  </div>
</template>

<script>
import Axios from "../../utils/Axios";

export default {
  name: "fFilter",
  props: {
    filterForm: [],
    needBtn: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      form: {
        deptId: [],
        eventState: "",
        eventType: "",
        status: "",
        riskLevel: "",
        alertLevel: "",
      },
      tree: [],
      startDate: "",
      endDate: "",
      enVEventType: [
        {
          label: "全部",
          value: "",
        },
      ],
      eventType: [
        {
          label: "全部",
          value: "",
        },
      ],
      options2: [],
      options3: [],
    };
  },
  methods: {
    queryTree() {
      Axios.ajax({
        url: "/dept/getDeptTree",
        method: "get",
      }).then((res) => {
        if (res.data) {
          this.tree = res.data;
          this.$emit("sendTree", this.tree);
        }
      });
    },
    queryEnvEventFaults() {
      Axios.ajax({
        url: "/peripheralEvents/getEventTypes",
        method: "post",
      }).then((res) => {
        if (res.data) {
          res.data.map((item) => {
            this.enVEventType.push({
              value: item.eventType,
              label: item.eventType,
            });
          });
        }
      });
    },
    queryEventFaults() {
      Axios.ajax({
        url: "/event/getFaults",
        method: "post",
      }).then((res) => {
        if (res.data) {
          res.data.map((item) => {
            this.eventType.push({
              value: item.faultCode,
              label: item.faultName,
            });
          });
        }
      });
    },
    getNowTime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期

      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      var MS = now.getMilliseconds(); //获取毫秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      if (MS < 100) MS = "0" + MS;

      var time = "";
      time =
        year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;

      var yesnow = new Date();
      yesnow.setTime(yesnow.getTime() - 30 * 24 * 60 * 60 * 1000);
      var yesyear = yesnow.getFullYear(); //得到年份
      var yesmonth = yesnow.getMonth(); //得到月份
      var yesdate = yesnow.getDate(); //得到日期

      var yeshour = yesnow.getHours(); //得到小时
      var yesminu = yesnow.getMinutes(); //得到分钟
      var yessec = yesnow.getSeconds(); //得到秒
      var yesMS = yesnow.getMilliseconds(); //获取毫秒
      yesmonth = yesmonth + 1;
      if (yesmonth < 10) yesmonth = "0" + yesmonth;
      if (yesdate < 10) yesdate = "0" + yesdate;
      if (yeshour < 10) yeshour = "0" + yeshour;
      if (yesminu < 10) yesminu = "0" + yesminu;
      if (yessec < 10) yessec = "0" + yessec;
      if (yesMS < 100) yesMS = "0" + yesMS;
      var yestime = "";
      yestime =
        yesyear +
        "-" +
        yesmonth +
        "-" +
        yesdate +
        " " +
        yeshour +
        ":" +
        yesminu +
        ":" +
        yessec;
      // this.startDate = yestime;
      // this.endDate = time;
    },
    init() {
      Object.keys(this.form).forEach((key) => {
        this.form[key] = "";
      });
      this.form.deptId = [];
      this.startDate = "";
      this.endDate = "";
      this.form.startDate = "";
      this.form.endDate = "";
    },
    onReset() {
      this.init();
      this.$nextTick(() => {
        this.$emit("on-reset", this.form);
      });
    },
    onSearch(key) {
      //key是为了每次筛选能回到第一页
      if (key) {
        this.form.startDate = this.startDate;
        this.form.endDate = this.endDate;
        this.$emit("sendForm", this.form, key);
      } else {
        this.form.startDate = this.startDate;
        this.form.endDate = this.endDate;
        this.$emit("sendForm", this.form);
      }
    },
    queryAlertLevels() {
      Axios.ajax({
        url: "/risk/getAlertLevels",
        method: "post",
      }).then(({ data }) => {
        this.options3 = data.map((item) => {
          return {
            label: item.alertLevelName,
            value: item.alertLevel,
          };
        });
        this.options3.unshift({ value: "", label: "全部" });
      });
    },
    queryRiskLevels() {
      Axios.ajax({
        url: "/alert/getRiskLevels",
        method: "post",
      }).then(({ data }) => {
        this.options2 = data.map((item) => {
          return {
            label: item.riskLevelName,
            value: item.riskLevel,
          };
        });
        this.options2.unshift({ value: "", label: "全部" });
      });
    },
  },
  created() {
    // this.getNowTime();
    this.queryTree();
    this.queryEventFaults();
    this.queryEnvEventFaults();
    this.queryRiskLevels();
    this.queryAlertLevels();
  },
  mounted() {
    this.onSearch();
  },
};
</script>

<style lang="less" scoped>
.filter {
  display: flex;
  &-form {
    flex: 1;
  }
  &-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    height: 40px;
    > label {
      box-sizing: content-box;
      padding-right: 12px;
      flex-shrink: 0;
      text-align: right;
      font-size: 16px;
      //color: $text-color;
    }
  }
  &-button {
    margin-left: 48px;
  }
}
</style>
